// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CkiOn","footer":"styles_footer__3JqL5"};